"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandom = exports.loadImage = exports.isAudioTrack = exports.isVideoTrack = exports.formatTime = void 0;
const formatTime = (s) => {
    const seconds = Math.floor(s);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    return (hours > 0 ? `${hours}:` : '') + `${(minutes % 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
};
exports.formatTime = formatTime;
const isVideoTrack = (track) => track.type === 'video';
exports.isVideoTrack = isVideoTrack;
const isAudioTrack = (track) => track.type === 'audio';
exports.isAudioTrack = isAudioTrack;
const loadImage = (url) => new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
});
exports.loadImage = loadImage;
const getRandom = (min, max) => {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
};
exports.getRandom = getRandom;
